import { Box, FormControl, MenuItem, Select, TextField, Typography } from "@mui/material"
import type { ReactElement } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { PAYMENT_RULE_EVENT_OPTIONS } from "../constants"
import type { PaymentTermsSchemaFormValues } from "../schemas/PaymentTermsSchema"

import {
  FIELD_ERROR_CLASSES,
  FIELD_LABEL_CLASSES,
  SELECT_STYLING_PROPS,
  TEXT_FIELD_STYLING_PROPS,
} from "@/constants/forms"

const AddPaymentRule = ({
  partsIndex = 0,
  optionsIndex = 0,
}: {
  partsIndex: number
  optionsIndex: number
}): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext<PaymentTermsSchemaFormValues>()

  return (
    <div>
      <Box className='flex gap-3'>
        <Controller
          name={`options.${optionsIndex}.parts.${partsIndex}.paymentRule.daysAfter`}
          control={control}
          render={({ field }) => (
            <Box className='relative'>
              <label className={FIELD_LABEL_CLASSES}>
                Days<span className='text-red-600'>*</span>
              </label>
              <TextField
                {...field}
                {...TEXT_FIELD_STYLING_PROPS}
                name={`options.${optionsIndex}.parts.${partsIndex}.paymentRule.daysAfter`}
                placeholder='-'
                slotProps={{
                  htmlInput: {
                    className: "hide-stepper",
                  },
                }}
              />
            </Box>
          )}
        />
        <Typography variant='body2' className='mt-6 content-center text-gray-700'>
          after
        </Typography>
        <Controller
          name={`options.${optionsIndex}.parts.${partsIndex}.paymentRule.event`}
          control={control}
          render={({ field }) => (
            <FormControl fullWidth className='relative w-[176px] content-end'>
              <Select
                {...field}
                {...SELECT_STYLING_PROPS}
                name={`options.${optionsIndex}.parts.${partsIndex}.paymentRule.event`}
              >
                {PAYMENT_RULE_EVENT_OPTIONS.map(({ label, value }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
        <Controller
          name={`options.${optionsIndex}.parts.${partsIndex}.paymentRule.percentage`}
          control={control}
          render={({ field }) => (
            <Box className='relative'>
              <label className={FIELD_LABEL_CLASSES}>
                Pay<span className='text-red-600'>*</span>
              </label>
              <TextField
                {...field}
                {...TEXT_FIELD_STYLING_PROPS}
                name={`options.${optionsIndex}.parts.${partsIndex}.paymentRule.percentage`}
                placeholder='-'
                slotProps={{
                  input: {
                    endAdornment: <Typography className='text-sm'>%</Typography>,
                  },
                  htmlInput: {
                    className: "hide-stepper",
                  },
                }}
              />
            </Box>
          )}
        />
        <Typography variant='body2' className='mt-6 content-center text-gray-700'>
          of full amount
        </Typography>
      </Box>
      <div className={FIELD_ERROR_CLASSES}>
        <div>{errors?.options?.[optionsIndex]?.parts?.[partsIndex]?.paymentRule?.daysAfter?.message}</div>
        <div>{errors?.options?.[optionsIndex]?.parts?.[partsIndex]?.paymentRule?.percentage?.message}</div>
        <div>{errors?.options?.[optionsIndex]?.parts?.[partsIndex]?.message}</div>
      </div>
    </div>
  )
}

export default AddPaymentRule
